import ready, { HTML } from 'Utils';

ready(() => {
  HTML.classList.add('is-loaded');
});

// jQuery document ready
// jQuery(function() {
//   // init functions
// });

// vanilla document ready
// document.addEventListener('DOMContentLoaded', function () {
//   // do something here ...
// }, false);
